module.exports = __webpack_public_path__ + "img/renwu@2x.73152ac2.png";